import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button, buttonClasses } from '@kawai/ui';

export interface PageHeaderLink {
  to: string;
  label: string;
}

export interface PageHeaderProps {
  title: ReactNode;
  /** 見出しの下の説明（15px / ink-2）。 */
  description?: ReactNode;
  /** 右側のページ遷移（白ボタン = ページ地色の上に置く副ボタン）。 */
  links?: ReadonlyArray<PageHeaderLink>;
  /** 右側の主導線（ブランド色のボタン / 例: ＋ テナント追加）。 */
  primary?: PageHeaderLink;
  email?: string | null;
  onSignOut?: () => void;
}

/**
 * S-137: saas-admin 各ページの見出し行（v2）。saas-admin は app-shell の左・上部メニューを持たず
 * 各ページがヘッダを描いていたので、ここに 1 本化する。罫線は引かず、余白と白ボタンで区切る。
 */
export function PageHeader({
  title,
  description,
  links = [],
  primary,
  email,
  onSignOut,
}: PageHeaderProps) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="text-h-page font-semibold text-ink">{title}</h1>
        {description && <p className="mt-1 text-body text-ink-2">{description}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {email && <span className="mr-1 text-label text-ink-3">{email}</span>}
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={buttonClasses({ v2: true, variant: 'paper', size: 'sm' })}
          >
            {l.label}
          </Link>
        ))}
        {primary && (
          <Link
            to={primary.to}
            className={buttonClasses({ v2: true, variant: 'primary', size: 'sm' })}
          >
            {primary.label}
          </Link>
        )}
        {onSignOut && (
          <Button type="button" variant="ghost" size="sm" v2 onClick={onSignOut}>
            サインアウト
          </Button>
        )}
      </div>
    </header>
  );
}
